/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { IColumn } from 'types'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'

export const useTableModel = () => {
  const { t } = useTranslation()

  const handleAuthorFormat = useCallback(
    (cellValue: string, row: any) => row.author?.title,
    [],
  )

  const handleGroupCourseFormat = useCallback(
    (cellValue: string, row: any) => row.group_course?.title,
    [],
  )

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any) => <MainTableActionButtons baseUrl='/assignments/' row={row} />,
    [],
  )

  const handleDateFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'dd-MM-yyyy') : ''),
    [],
  )

  const handleStatusFormat = useCallback(
    (cellValue: string) => (cellValue ? t(`assignment-statuses.${cellValue}`) : ''),
    [],
 )

  const columns: IColumn[] = [

    {
      title: `${t('common.title')}`,
      field: 'title',
      order: true,
      width: '30%',
    },
    {
      title: `${t('common.group-course')}`,
      field: 'group_course',
      width: '25%',
      order: true,
      format: handleGroupCourseFormat,
    },
    {
      title: `${t('common.author')}`,
      field: 'author',
      width: '15%',
      order: true,
      format: handleAuthorFormat,
    },

    {
      title: `${t('assignments.assignment-status')}`,
      field: 'status',
      order: true,
      width: '10%',
      format: handleStatusFormat
    },

    {
      title: `${t('common.due-date')}`,
      field: 'due_datetime',
      width: '10%',
      order: true,
      format: handleDateFormat,
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      cellClass: 'mobile-first-cell',
      format: handleActionsFormat,
    },
  ]

  return columns
}
